










































































import { Component, Vue, Prop } from 'vue-property-decorator';
import POAExtensionRecord from '@/entities/POAExtensionRecord';

@Component({
  components: {},
})
export default class POAExtensionRecordDisplay extends Vue {
  @Prop({ required: true }) public ticket!: POAExtensionRecord;

  public formatDate(value: number) {
    const date = new Date(value * 1000);
    return date.toLocaleDateString(this.$i18n.locale, {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'UTC',
    });
  }

  protected get getName(): string {
    let nameParts = new Array();

    if (this.ticket.lastName.trim().length > 0) {
      nameParts.push(this.ticket.lastName.trim());
    }
    if (this.ticket.firstName.trim().length > 0) {
      nameParts.push(this.ticket.firstName.trim());
    }

    let nameStr = nameParts.join(', ');
    if (nameStr.length < 1) {
      nameStr = '-';
    }
    return nameStr;
  }
}
